import { create } from 'zustand';

interface ChatState {
  isOpen: boolean;
  initialMessage: string | null;
  openChat: () => void;
  closeChat: () => void;
  toggleChat: () => void;
  setOpen: (open: boolean) => void;
  askRaiko: (message: string) => void;
  clearInitialMessage: () => void;
}

export const useChatStore = create<ChatState>()((set) => ({
  isOpen: false,
  initialMessage: null,
  openChat: () => set({ isOpen: true }),
  closeChat: () => set({ isOpen: false }),
  toggleChat: () => set((state) => ({ isOpen: !state.isOpen })),
  setOpen: (open) => set({ isOpen: open }),
  askRaiko: (message) => set({ initialMessage: message, isOpen: true }),
  clearInitialMessage: () => set({ initialMessage: null }),
}));
